var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-less") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Adherence-Phase-1",
    transform: "translate(-127.000000, -831.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-less",
    transform: "translate(127.000000, 831.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D1DCE6",
    cx: 8.5,
    cy: 8.5,
    r: 8.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "-",
    fill: "#44484C",
    fillRule: "nonzero",
    points: "12 10 12 8 5 8 5 10"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLess);
export default __webpack_public_path__ + "static/media/ico-less.feb0aa7587d4b14bd65b5c5d7d8cf943.svg";
export { ForwardRef as ReactComponent };